import { BraxSelectOption } from 'design-system';

export type PaymentInstallments = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

const paymentInstallments: BraxSelectOption<PaymentInstallments>[] = [{
    value: 1,
    title: '1x'
}, {
    value: 2,
    title: '2x'
}, {
    value: 3,
    title: '3x'
}, {
    value: 4,
    title: '4x'
}, {
    value: 5,
    title: '5x'
}, {
    value: 6,
    title: '6x'
}, {
    value: 7,
    title: '7x'
}, {
    value: 8,
    title: '8x'
}, {
    value: 9,
    title: '9x'
}, {
    value: 10,
    title: '10x'
}, {
    value: 11,
    title: '11x'
}, {
    value: 12,
    title: '12x'
}];

export default paymentInstallments;
